module.exports = __webpack_public_path__ + "img/1.8.C.46311bde.png";